import { render, staticRenderFns } from "./CChartBarExample.vue?vue&type=template&id=37fd1bfe&"
import script from "./CChartBarExample.vue?vue&type=script&lang=js&"
export * from "./CChartBarExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports